import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    adminleftnavnum:"survey" //管理后台左侧导航
  },
  mutations: {

  },
  actions: {

  }
})
